/** What the workspace remembers about a day while you work elsewhere: where you were and what you had picked. */
export type WorkspaceSession = {
  scrollTop?: number;
  /** Keys of the ticked tickets. */
  selected?: string[];
  /** Keys of the folded drivers. */
  collapsed?: string[];
};

const PREFIX = "ots.driver-activity.session.";

/**
 * The session saved for a day, or nothing. Session storage, so it lasts while going back and forth between pages
 * but not into tomorrow's browser; private windows and blocked storage simply remember nothing.
 */
export const readWorkspaceSession = (key: string | undefined): WorkspaceSession => {
  if (!key) return {};
  try {
    const saved = JSON.parse(sessionStorage.getItem(PREFIX + key) ?? "null");
    return saved && typeof saved === "object" ? saved as WorkspaceSession : {};
  } catch {
    return {};
  }
};

/** Merges a change into the day's saved session. */
export const writeWorkspaceSession = (key: string | undefined, patch: WorkspaceSession) => {
  if (!key) return;
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify({ ...readWorkspaceSession(key), ...patch }));
  } catch {
    // Storage full or blocked: the session just isn't remembered.
  }
};
